import type { CSSProperties } from 'react';

interface City {
  id: string;
  x: number;
  y: number;
  delay: number;
}

const cities: City[] = [
  { id: 'london', x: 47, y: 30, delay: 0 },
  { id: 'paris', x: 49, y: 33, delay: 0.4 },
  { id: 'cairo', x: 55, y: 43, delay: 0.8 },
  { id: 'lagos', x: 52, y: 55, delay: 1.2 },
  { id: 'abidjan', x: 47, y: 51, delay: 1.6 },
  { id: 'nairobi', x: 62, y: 58, delay: 2.0 },
  { id: 'johannesburg', x: 56, y: 74, delay: 2.4 },
  { id: 'dubai', x: 61, y: 47, delay: 0.6 },
  { id: 'beijing', x: 74, y: 39, delay: 1.0 },
  { id: 'tokyo', x: 84, y: 37, delay: 1.8 },
  { id: 'newyork', x: 28, y: 36, delay: 0.2 },
  { id: 'saopaulo', x: 33, y: 70, delay: 2.2 },
];

function CityDots({ offset = 0 }: { offset?: number }) {
  return (
    <>
      {cities.map((city) => (
        <span
          key={`${city.id}-${offset}`}
          className="globe-city"
          style={
            {
              left: `${offset + city.x}%`,
              top: `${city.y}%`,
              '--delay': `${city.delay}s`,
            } as CSSProperties
          }
        />
      ))}
    </>
  );
}

function Globe({ className = '' }: { className?: string }) {
  return (
    <div className={`relative ${className}`}>
      {/* Soft ambient glow behind the globe */}
      <div className="absolute -inset-6 rounded-full bg-primary-500/15 blur-3xl" />
      <div className="absolute -inset-2 rounded-full bg-accent-500/10 blur-2xl" />

      {/* Spinning earth sphere */}
      <div className="globe relative w-full h-full rounded-full overflow-hidden">
        <div
          className="globe-texture"
          style={{
            backgroundImage:
              'url(https://readdy.ai/api/search-image?query=Seamless%20equirectangular%20flat%20world%20map%20texture%2C%20glowing%20network%20lines%20connecting%20continents%2C%20dark%20deep%20navy%20blue%20ocean%2C%20electric%20cyan%20and%20blue%20luminous%20connection%20dots%2C%20futuristic%20digital%20hologram%20earth%20projection%2C%20dark%20glowing%20continents%2C%20high%20detail%2C%20flat%202D%20projection%2C%20no%20text%2C%20no%20sphere&width=1600&height=800&seq=earth-texture-01&orientation=landscape)',
          }}
        />

        {/* Connected cities (rotating with the earth) */}
        <div className="globe-cities">
          <CityDots offset={0} />
          <CityDots offset={100} />
        </div>

        <div className="globe-shading" />
      </div>

      {/* Orbital ring */}
      <div className="globe-orbit absolute inset-0 rounded-full" />
    </div>
  );
}

export default Globe;